
  <div class="ontario-row center-column-container">
    <div class="bpsss-border-line" style="margin-bottom: 28px"></div>
    
    <div class="ontario-column ontario-small-12 center-row-container">
      <button tabindex="101" (click)="onCertificateLogin()" 
        class="ontario-button ontario-button--primary" style="margin-top: 0px; margin-bottom: 10px; max-width: 36ex;"
        id="certificate-button" title="{{ 'bss.login.x509.certificate.title' | translate }}">
          {{ 'bss.login.x509.certificate' | translate }}
      </button>
    </div>
    <div class="bpsss-border-line" style="margin-bottom: 10px"></div>
  </div>